export const props = {
  prizes: {
    type: Array,
    default: () => [],
  },
  animation: { // 是否需要旋转
    type: Boolean,
    default: true,
  },
  speed: {
    type: Number,
    default: 0.2,
  },
  factor: {
    type: Number,
    default: 0.995,
  },
  loop: {
    type: Number,
    default: 2,
  },
  rotate: { // 是否旋转奖品
    type: Boolean,
    default: false,
  },
  showPointer: { // 是否显示指针
    type: Boolean,
    default: true,
  },
  activeClass: {
    type: String,
    default: 'active',
  },
  pointerTransform: { // 指针的transform
    type: String,
    default: 'translate3d(-50%, -60%, 0)',
  },
  prizeClass: {
    type: String,
    default: 'prize',
  },
  btnText: {
    type: String,
    default: '',
  },
}
